import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UpgradeForFormAutomationView = ({
  auditResult
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal('forms-simple-automation-xray');
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    testId: "add-form-follow-up-email",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.UPGRADE_FOR_FORM_AUTOMATION"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.UPGRADE_FOR_FORM_AUTOMATION"
    }),
    status: auditResult.status,
    children: /*#__PURE__*/_jsx("div", {
      className: "m-left-6 m-bottom-2",
      children: /*#__PURE__*/_jsxs(UILink, {
        onClick: openUpgradeModal,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "locked"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "xray-recommendation-lib.seo.recommendations.linkText.UPGRADE_FOR_FORM_AUTOMATION"
        })]
      })
    })
  });
};